import { useLayoutEffect, useRef } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
// import Lottie from "lottie-react";

// import visualNdt from "../lottie/visual-testing.json";
// import liquidTesting from "../lottie/visual-testing.json";

// images
import card01 from "../assets/image/Home/cards/Poultry-processing-plants.png"
import card02 from "../assets/image/Home/cards/Further-processing-.png"
import card03 from "../assets/image/Home/cards/Ready-meals.png"
// import card04 from "../assets/image/Home/cards/Ready-meals.png"

gsap.registerPlugin(ScrollTrigger);

export default function ServicesCards() {
  const sectionRef = useRef();

  useLayoutEffect(() => {
    const ctx = gsap.context(() => {
gsap.utils.toArray(".service-frame").forEach((card) => {
  const wrapper = card.querySelector(".service-wrapper");

  gsap.fromTo(
    wrapper,
    {
      y: 120,
      rotateX: 120,   // starts leaning away
      scale: 0.94,
      opacity: 0
    },
    {
      y: 0,
      rotateX: 0, // 👈 final tilt from Webflow
      scale: 1,
      opacity: 1,
      ease: "power3.out",
      scrollTrigger: {
        trigger: card,
        start: "top 80%",
        end: "top 30%",
        scrub: true
      }
    }
  );
});
  

    }, sectionRef);

    return () => ctx.revert();
  }, []);

  return (
    <section ref={sectionRef} className="section-12 is-overflow">
     <div className="container-lg">
 {/* ===================== */}
      {/* SERVICE CARD 1 */}
      {/* ===================== */}
      <div className="services-container">

      

    <div className="service-frame is-1">
    <div className="service-wrapper">
        <div className="flex-l-t is-serv-col-1">
            <div className="big-no-wrapper">
                <div className="big-no">01</div>
            </div>
            <div className="big-animation-wrapper bg-black">
                <div className="big-animation">
                   <img src={card01} alt="services" />
                </div>
            </div>
        </div>
        <div className="flex-v-l-split is-s-card-content">
            <div className="h2-frame">
                <div className="h2-wrap row-1">
                    <h2 className="h2">
                       Poultry processing</h2>
                </div>
                <div className="h2-wrap row-2">
                    <h2 className="h2">
                        plants</h2>
                </div>
            </div>
            <div className="flex-r-s is-100">
                <p className="text d-60 mobile-max">Complete solutions for receiving, slaughter, deboning, marination, grading, and packing lines. We deliver hygienic conveyors, integrated processing equipment, and sanitation-focused designs built to support high-throughput poultry operations with consistent performance and easy cleaning.<br/>
                </p>
            </div>
        </div>
        <div className="flex-v-l-split is-s-card-content is-mobile">
            <div className="h2-frame">
                <div className="h2-wrap row-1">
                    <h2 className="h2-stroke is-black is-mobile-change">
                        Poultry processing</h2>
                </div>
                <div className="h2-wrap row-2">
                    <h2 className="h2-stroke is-black is-mobile-change">
                      plants</h2>
                </div>
            </div>
            <div className="flex-r-s is-100">
                <p className="text d-60 mobile-max">Complete solutions for receiving, slaughter, deboning, marination, grading, and packing lines. We deliver hygienic conveyors, integrated processing equipment, and sanitation-focused designs built to support high-throughput poultry operations with consistent performance and easy cleaning.<br/></p>
            </div>
        </div>
    </div>
</div>





        {/* ===================== */}
        {/* SERVICE CARD 2 */}
        {/* ===================== */}
 <div className="service-frame is-2">
    <div className="service-wrapper bg-black">
        <div className="flex-v-l-split is-s-card-content">
            <div className="h2-frame">
               
                <div className="h2-wrap row-2">
                    <h2 className="h2-stroke is-black">
                        further processing</h2>
                </div>
            </div>
            <div className="flex-r-s is-100">
                <p className="text txt-white d-60 mobile-max">Integrated FoodSafe solutions for sausages, salami, patties, and value-added products. We provide hygienic conveyors, process equipment, and plant designs that support controlled handling, product segregation, and consistent quality across mixing, forming, cooking, cooling, and packing operations.</p>
            </div>
        </div>
        <div className="flex-l-t is-serv-col-1">
            <div className="big-animation-wrapper bg-white">
                <div className="big-animation">
                   <img src={card02} alt="services" />
                </div>
            </div>
            <div className="big-no-wrapper">
                <div className="big-no">02</div>
            </div>
        </div>
        <div className="flex-v-l-split is-s-card-content is-mobile">
            <div className="h2-frame">
                
                <div className="h2-wrap row-2">
                    <h2 className="h2-stroke is-black is-mobile-change">
                        further processing</h2>
                </div>
            </div>
            <div className="flex-r-s is-100">
                <p className="text d-60 mobile-max">Integrated FoodSafe solutions for sausages, salami, patties, and value-added products. We provide hygienic conveyors, process equipment, and plant designs that support controlled handling, product segregation, and consistent quality across mixing, forming, cooking, cooling, and packing operations.</p>
            </div>
        </div>
    </div>
</div>



    <div className="service-frame is-3">
    <div className="service-wrapper">
        <div className="flex-l-t is-serv-col-1">
            <div className="big-no-wrapper">
                <div className="big-no">03</div>
            </div>
            <div className="big-animation-wrapper bg-black">
                <div className="big-animation">
                   <img src={card03} alt="services" />
                </div>
            </div>
        </div>
        <div className="flex-v-l-split is-s-card-content">
            <div className="h2-frame">
                <div className="h2-wrap row-1">
                    <h2 className="h2">
                      Ready meals </h2>
                </div>
                
            </div>
            <div className="flex-r-s is-100">
                <p className="text d-60 mobile-max">FoodSafe conveyors, hygienic structures, and digital food safety tools for RTE and RTC production. Our solutions help maintain process segregation, traceability, and validated cleaning, supporting safe, compliant, and efficient ready-meal operations.<br/>
                </p>
            </div>
        </div>
        <div className="flex-v-l-split is-s-card-content is-mobile">
            <div className="h2-frame">
                <div className="h2-wrap row-1">
                    <h2 className="h2-stroke is-black is-mobile-change">
                        Ready meals </h2>
                </div>
               
            </div>
            <div className="flex-r-s is-100">
                <p className="text d-60 mobile-max">FoodSafe conveyors, hygienic structures, and digital food safety tools for RTE and RTC production. Our solutions help maintain process segregation, traceability, and validated cleaning, supporting safe, compliant, and efficient ready-meal operations.<br/></p>
            </div>
        </div>
    </div>
</div>


      </div>

    
     </div>
     
  
    </section>
  );
}